(function($) {

  var $cursor = $('#CustomCursor');

  if( $cursor.length ) {

    var flag = false;

    var $body = $('body');
      $body.css('cursor','none');
      $body.on('mouseover', mouseover);
      $body.on('mouseout', mouseout);
      $body.on('mousemove', mousemove);
      $body.on('click', clickevent);

    var $componentpanels = $('.component-panel');
      $componentpanels.css('cursor','none');
      $componentpanels.on('mouseover', mouseover);
      $componentpanels.on('mouseout', mouseout);
      $componentpanels.on('mousemove', mousemove);

    function mouseover( e ) {
      if( flag === true ) return;
      flag = true;
      $cursor.css('opacity', 1);
    }

    function mouseout( e ) {
      if( flag === false ) return;
      flag = false;
      $cursor.css('opacity', 0);
    }

    function mousemove( e ) {
      if( false === flag ) return;

      var link = false;
      var done = false;

      var $target = $(e.target);

      if( $body.hasClass('navigationpanel-open') ||
        $body.hasClass('sphere-overlay-showing') ) {

        if( $target.hasClass('component-panel-overlay')) {
          $target.css('cursor', 'none');
          $cursor.addClass('close');
          $cursor.removeClass('link');
        } else {
          link = true;
        }
        done = true;
      }

      if( link || (
        ($target.prop('tagName') == 'A') ||
        $target.hasClass('hamburger-box') ||
        $target.hasClass('hamburger-inner') ||
        $target.hasClass('menu-item') ||
        $target.hasClass('headroom-header') ||
        $target.hasClass('p5Canvas') ||
        $target.hasClass('cursor-link')
      )) {
        $target.css('cursor', 'none');
        $cursor.addClass('link');
        $cursor.removeClass('close');
        done = true;
      }

      if( !done ) {
        $cursor.removeClass('link');
        $cursor.removeClass('close');
      }

      if( e.pageY > (window.innerHeight / 2) ) {
        $cursor.addClass('rotated');
      } else {
        $cursor.removeClass('rotated');
      }

      $cursor.css('left', e.pageX - 28);
      $cursor.css('top', e.pageY - 28);
    };
  }

  function clickevent( e ) {
    if( $cursor.hasClass('link') || $cursor.hasClass('close'))
      return;
    if( typeof window.slideControler == undefined )
      return;
    if( $cursor.hasClass('rotated')) {
      window.slideControler.next();
    } else {
      window.slideControler.previous();
    }
  }

})(jQuery);